var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',_vm._b({attrs:{"config":_vm.configs,"placeholder":'请选择时间'},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'flat-pickr',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }